var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiPatner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UsersThree",
    clipPath: "url(#clip0_26049_19244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.667 18.75C32.1226 18.7489 33.5584 19.0873 34.8604 19.7383C36.1623 20.3892 37.2945 21.3349 38.167 22.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.16699 22.5C4.03949 21.3349 5.17168 20.3892 6.47362 19.7383C7.77556 19.0873 9.21138 18.7489 10.667 18.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.667 28.75C24.1188 28.75 26.917 25.9518 26.917 22.5C26.917 19.0482 24.1188 16.25 20.667 16.25C17.2152 16.25 14.417 19.0482 14.417 22.5C14.417 25.9518 17.2152 28.75 20.667 28.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.917 33.75C12.8143 32.2273 14.0935 30.9651 15.6281 30.0882C17.1627 29.2112 18.8995 28.75 20.667 28.75C22.4345 28.75 24.1713 29.2112 25.7059 30.0882C27.2405 30.9651 28.5197 32.2273 29.417 33.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.8232 12.5C26.057 11.5946 26.54 10.773 27.2173 10.1283C27.8946 9.48362 28.7391 9.04179 29.6549 8.85299C30.5707 8.66418 31.5211 8.73597 32.3981 9.06018C33.2752 9.3844 34.0438 9.94806 34.6165 10.6871C35.1893 11.4262 35.5434 12.3111 35.6385 13.2413C35.7337 14.1715 35.566 15.1098 35.1547 15.9495C34.7434 16.7892 34.1048 17.4968 33.3115 17.9918C32.5182 18.4869 31.6021 18.7495 30.667 18.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.6674 18.75C9.73234 18.7495 8.81615 18.4869 8.02288 17.9918C7.2296 17.4968 6.59104 16.7892 6.1797 15.9495C5.76836 15.1098 5.60074 14.1715 5.69587 13.2413C5.79099 12.3111 6.14506 11.4262 6.71785 10.6871C7.29064 9.94806 8.05921 9.3844 8.93626 9.06018C9.81331 8.73597 10.7637 8.66418 11.6795 8.85299C12.5953 9.04179 13.4398 9.48362 14.1171 10.1283C14.7944 10.773 15.2774 11.5946 15.5112 12.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26049_19244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPatner);
export default __webpack_public_path__ + "static/media/MultiPatner.52936cd8a84156ccc14a005507dd11f2.svg";
export { ForwardRef as ReactComponent };